import { OnInit, Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from 'app/shared/services/security.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalEmployeesComponet } from 'app/views/modales/employees/modal-employees.component';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IDtoLiquidation } from 'app/shared/models/legal/dto-liquidation.model';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { EmployeeService } from 'app/views/appviews/employee.service';
@Component({
    selector: 'app-liquidation',
    styleUrls: ['liquidation.style.scss'],
    templateUrl: 'liquidation.template.html'
})
export class LiquidationComponent implements OnInit {
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private modalRef: BsModalRef;
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    private employee: IDtoEmployee;
    private hasEmployee = false;
    private formLiquidation: FormGroup;
    private liquidation: IDtoLiquidation;
    private actionLiquidation: string;
    constructor(private spinner: NgxSpinnerService
        , private securityService: SecurityService
        , private modalService: BsModalService
        , private formBuilder: FormBuilder
        , private route: ActivatedRoute
        , private configurationService: ConfigurationService
        , private employeeService: EmployeeService) {
       
    }
    ngOnInit(): void {
        this.initializeFormLiquidation();
        if (this.configurationService.isReady) {
            
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                
            });
        }
        this.route.params.subscribe((params) => {
            if (params['employeeId']) {
                setTimeout(() => {
                    this.spinner.show();
                    if (this.configurationService.isReady) {
                        //this.liquidationId = params['id'];
                        let employeeId = params['employeeId'];
                        let requisitionId = params['requisitionId'];
                        this.actionLiquidation = params['actionLiquidation'];
                        this.getEmployeeData(requisitionId);
                    } else {
                        this.configurationService.settingsLoaded$.subscribe(x => {
                            //this.liquidationId = params['id'];
                            let employeeId = params['employeeId'];
                            let requisitionId = params['requisitionId'];
                            this.actionLiquidation = params['actionLiquidation'];
                            this.getEmployeeData(requisitionId);
                        });
                    }
                }, 2);
            }
        });
    }
    private initializeFormLiquidation() {
        this.formLiquidation = this.formBuilder.group({
            employee: [null, Validators.required]
        });
    }
    private calculateLaborSeniorityDesc(): void {
        let diff = new Date(this.employee.dismissalDate).getTime() - new Date(this.employee.hiringDate).getTime();
        let days = diff / (1000 * 60 * 60 * 24);
        if (days <= 90) {
            this.employee.laborSeniorityDesc = 'Menor a 3 meses';
        } else {
            this.employee.laborSeniorityDesc = 'Mayor a 3 meses';
        }
    }
    private openModalEmployees() {
        const initialState = {
            module: 'Liquidation',
        };
        this.modalRef = this.modalService.show(ModalEmployeesComponet
            , Object.assign({ initialState }, { class: 'modal-lg' }, this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.formLiquidation.reset();
                this.employee = result;
                this.calculateLaborSeniorityDesc();
                this.formLiquidation.get('employee').setValue(this.employee.employeeName);
                this.hasEmployee = true;
                this.actionLiquidation = 'add';
                //this.getLiquidation();
            } else {
                this.hasEmployee = false;
            }
        });
    }

    private getEmployeeData(requisitionId: number): void {
        this.spinner.show();
        this.employeeService.getEmployeeDataDismissalById(requisitionId).subscribe((res) => {
            this.employee = res;
            this.calculateLaborSeniorityDesc();
            this.formLiquidation.get('employee').setValue(this.employee.employeeName);
            this.hasEmployee = true;
            this.spinner.hide();
        });
    }
   
}
